<template>
    <div class="dragAndCopyUpload">
        <div class="contentBox-img">
            <div class="attachmentLeft"
                 v-show="imgList.length">
                <div style="height: 180px">
                    <ul id="viewers"
                        style="display: none">
                        <li v-for="(item, index) in srcList"
                            :key="`${item}-${index}`">
                            <img :src="item" />
                        </li>
                    </ul>
                </div>
                <div class="currentImgIndex">{{ carouselIndex + 1 + ' / ' + imgList.length }}</div>
            </div>
             <div class="uploader" v-if="imgList.length">
                <el-upload ref="ossElUpload"
                           class="dragAndCopyUpload-class"
                           action="upload"
                           :accept="accept"
                           :drag="drag"
                           :multiple="multiple"
                           :http-request="submitUpload"
                           :show-file-list="showFileList"
                           :disabled="disabled"
                           :before-upload="handleBeforeUpload"
                           :on-remove="handleRemove">
                    <i class="el-icon-plus pictures"></i>
                </el-upload>
                <i class="el-icon-delete" @click="deleteBtn"></i>
            </div>
             <div v-else>
                <el-upload ref="ossElUpload"
                           class="dragAndCopyUpload-class"
                           action="upload"
                           :accept="accept"
                           :drag="drag"
                           :multiple="multiple"
                           :http-request="submitUpload"
                           :show-file-list="showFileList"
                           :disabled="disabled"
                           :before-upload="handleBeforeUpload"
                           :on-remove="handleRemove">
                    <i class="el-icon-plus notImg"></i>
                </el-upload>
            </div>

            <div class="drag-tip">将图片拖至“加号”上传，或点击上传</div>
            <div class="input-upload-copy">
                <input class="input-upload-paste"
                       :disabled="loading"
                       placeholder="截图后，在此处粘贴（Ctrl+V）上传图片"
                       v-on:paste="handlePaste" />
            </div>
        </div>
    </div>
</template>

<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
import { ossUpload } from '@/components/lots/OSS/api.js';
import { imageMinimize } from '../../util';
const BYTES_UNIT = 1024;

export default {
    components: {},
    props: {
        propertiesList: {
            type: Array,
            default () {
                return [];
            }
        },
        bucket: {
            type: String,
            default: 'c-tms'
        },
        maxFileCount: {
            type: Number,
            default: 6
        },
        businessKey: {
            type: String,
            default: 'default'
        },
        publicRead: {
            type: [Number, String],
            default: 1
        },
        contentType: {
            // 上传内容类型
            type: String,
            default: 'application/octet-stream'
        },
        showFileList: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        drag: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'button'
        },
        text: {
            type: String,
            default: '请选择文件'
        },
        icon: {
            type: String,
            default: 'el-icon-upload'
        },
        accept: {
            type: String,
            default: '.png,.jpg,.jpeg,.dox,.docx,.xls,.xlsx'
        },
        maxSize: {
            // 单张文件大小，默认8M
            type: Number,
            default: 8
        },
        multiple: {
            // 是否支持多选上传
            type: Boolean,
            default: false
        },
        onlyUploadOne: {
            // 仅支持上传单张，若已上传了文件，则替换上一次上传的文件
            type: Boolean,
            default: false
        },
        compressImage: {
            // 5MB以上图片上传，是否进行图片压缩后再上传
            type: Boolean,
            default: false
        },
        compressQuality: {
            // 图片压缩的质量
            type: Number,
            default: 0.5
        },
        customClass: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            viewer: {},
            carouselIndex: 0, // 轮播图当前的索引
            loading: false, // 上传按钮加载动画
            srcList: [], // 当前图片列表
            imgList: [],
            uploadList: [], // 上传文件响应集合
            uploadFileList: [], // 文件上传前的临时文件
            cancelUpload: false, // 是否取消上传
            uploadingCount: 0 // 当前正在上传的数量
        };
    },

    methods: {
        updateViewer () {
            this.carouselIndex = 0;
            this.viewer.destroy();
            setTimeout(() => {
                this.initViewer();
            });
        },
        // 获取文件类型
        getFileType (name) {
            const type = name.split('.')[1];
            return type.toUpperCase();
        },
        // 删除图片
        deleteBtn () {
            // 先获取要删除的 uploadList 项，以便通过 uid 匹配删除 uploadFileList
            let deletedUploadItem = null;
            if (this.uploadList.length > this.carouselIndex) {
                deletedUploadItem = this.uploadList[this.carouselIndex];
                this.uploadList.splice(this.carouselIndex, 1);
            }

            // 删除 propertiesList 和 imgList
            this.propertiesList.splice(this.carouselIndex, 1);
            this.imgList = this.propertiesList;

            // 根据 uid 从 uploadFileList 中删除对应的项（更准确）
            if (deletedUploadItem && deletedUploadItem.uid) {
                const delIndex = this.uploadFileList.findIndex(
                    (v) => v.uid === deletedUploadItem.uid
                );
                if (delIndex > -1) {
                    this.uploadFileList.splice(delIndex, 1);
                }
            } else if (this.uploadFileList.length > this.carouselIndex) {
                // 如果找不到 uid，则使用索引删除（兼容处理）
                this.uploadFileList.splice(this.carouselIndex, 1);
            }

            // 使用 shows() 方法重新生成 srcList 并更新 viewer
            this.shows();
        },
        initViewer (resolve) {
            if (this.srcList.length > 0) {
                const barOptions = { show: true, size: 'default' };
                this.viewer = new Viewer(document.getElementById('viewers'), {
                    inline: true,
                    title: false,
                    navbar: true,
                    button: true,
                    focus: false, // 关闭页面自动定位到viewer
                    zIndexInline: 10086,
                    backdrop: true, // 透明背景色
                    zoomOnWheel: true, // 滚动缩放
                    toolbar: {
                        zoomIn: barOptions,
                        zoomOut: barOptions,
                        prev: {
                            show: true,
                            size: 'default',
                            click: () => {
                                if (this.carouselIndex === 0) {
                                    return this.$message.warning('当前图片是第一张');
                                } else {
                                    this.carouselIndex -= 1;
                                    this.viewer.prev(true);
                                }
                            }
                        },
                        play: barOptions,
                        next: {
                            show: true,
                            size: 'default',
                            click: () => {
                                if (this.carouselIndex === this.imgList.length - 1) {
                                    return this.$message.warning('当前图片是最后一张');
                                } else {
                                    this.carouselIndex += 1;
                                    this.viewer.next(true);
                                }
                            }
                        },
                        rotateLeft: barOptions,
                        rotateRight: barOptions

                    },
                    viewed: data => { // 图片加载完成时回调
                        this.updateInfo(data.detail.index);
                        resolve();
                    }
                });
            }
        },

        /**
         * @description 切换图片时，更新图片上传信息
         * @param {Number} index 当前显示图片索引
         */
        updateInfo (index) {
            this.carouselIndex = index;
        },

        shows () {
            this.viewer.element && this.viewer.destroy(); // 删除viewer上一次的实例
            this.srcList = this.imgList.map(v => v.propertiesValue);
            this.$nextTick(() => {
                new Promise(resolve => {
                    this.initViewer(resolve);
                }).then(() => {});
            });
        },

        /**
         * @description 删除已上传文件
         * @param {Object} file 文件对象
         */
        deleteUploadFiles (file) {
            const uploadFiles = this.$refs.ossElUpload.uploadFiles;
            const delFileIndex = uploadFiles.findIndex(
                (v) => file.uid === v.uid
            );
            uploadFiles.splice(delFileIndex, 1);
        },

        /**
         * @description 文件上传之前回调
         * @param {Object} file 文件对象
         */
        handleBeforeUpload (file) {
            // 限制文件上传大小
            if (file.size > this.maxSize * BYTES_UNIT * BYTES_UNIT) {
                this.deleteUploadFiles(file);
                this.cancelUpload = true;
                this.$message.warning(
                    `上传文件大于${this.maxSize}MB，请重新上传`
                );
                return false;
            }
            // 限制文件上传格式
            const fileNameSuffix = '.' + file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
            const fileWhiteList = this.accept.split(',');
            if (fileWhiteList.indexOf(fileNameSuffix) === -1) {
                this.$message.warning(`上传文件只能是${this.accept}格式`);
                return false;
            }
            this.cancelUpload = false;
            // 是否只允许上传一张
            if (
                this.onlyUploadOne &&
                this.$refs.ossElUpload.uploadFiles.length > 1
            ) {
                const uploadFiles = this.$refs.ossElUpload.uploadFiles;
                uploadFiles.splice(0, uploadFiles.length, file);
            }
            // 先检查总数，再决定是否添加到 uploadFileList
            // 基于已上传成功的文件数量（propertiesList）和正在上传的文件数量（uploadFileList）来判断
            const currentUploadingCount = this.uploadFileList.length;
            const totalCount = this.propertiesList.length + currentUploadingCount + 1; // +1 是当前要上传的文件
            if (totalCount > this.maxFileCount) {
                this.cancelUpload = true;
                this.$message.warning(`最多只能上传${this.maxFileCount}个附件,请重新上传！`);
                return false;
            }
            this.cancelUpload = false;
            // 多选时，将上传前的文件保存起来（检查通过后再添加）
            if (this.multiple) {
                this.uploadFileList.push(file);
            }
        },
        // 移除文件回调
        handleRemove (file, fileList) {
            const delFileIndex = this.uploadList.findIndex(
                (v) => v.uid === file.uid
            );
            if (delFileIndex > -1) {
                this.uploadList.splice(delFileIndex, 1);
            }
            const delIndex = this.uploadFileList.findIndex(
                (v) => v.uid === file.uid
            );
            if (delIndex > -1) {
                this.uploadFileList.splice(delIndex, 1);
            }
        },
        // 粘贴文件
        async handlePaste (event) {
            const items = (event.clipboardData || window.clipboardData).items;
            let file = null;
            if (!items || items.length === 0) {
                this.$message.warning('当前浏览器不支持粘贴图片，请使用点击上传');
                return;
            }
            for (let i = 0; i < items.length; i++) {
                file = items[i].getAsFile();
                break;
            }
            if (!file) {
                this.$message.warning('粘贴内容为非图片，请重新截图');
                return;
            }
            // 为粘贴的文件手动添加 uid，使其与上传功能保持一致
            if (!file.uid) {
                file.uid = Date.now() + Math.random();
            }
            if (!file.name) {
                file.name = `pasted-image-${Date.now()}.png`;
            }
            await this.handleBeforeUpload(file);
            this.copySubmitUpload(file);
        },

        // 粘贴文件上传
        async copySubmitUpload (uploadData) {
            if (this.cancelUpload) {
                return;
            }
            this.uploadingCount++; // 开始上传
            this.loading = true;
            const theFile = await this.imageFileProcess(uploadData);
            const file = new File([theFile], uploadData.name, {
                type: uploadData.type
            });
            const formData = new FormData();
            formData.append('file', file);
            formData.append('bucket', 'c-tms');
            formData.append('businessKey', 'default');
            formData.append('publicRead', 1);
            formData.append('contentType', this.contentType);
            ossUpload(formData).then((res) => {
                if (res && +res.code === 0) {
                    const list = {
                        ...res
                    };
                    list.data.name = uploadData.name;
                    list.data.size = file.size;
                    // 保存文件的 uid，用于匹配 uploadFileList
                    list.uid = uploadData.uid;
                    this.uploadList.push(list);
                    this.propertiesList.push(this.callbackFileInfo(list));
                    // 上传成功后，从 uploadFileList 中移除对应的文件
                    if (this.multiple && uploadData.uid) {
                        const fileIndex = this.uploadFileList.findIndex(
                            f => f.uid === uploadData.uid
                        );
                        if (fileIndex > -1) {
                            this.uploadFileList.splice(fileIndex, 1);
                        }
                        this.imgList = this.propertiesList;
                    }
                }
            })
                .finally(() => {
                    this.uploadingCount--;
                    // 统一刷新 只有当没有上传任务时才刷新 Viewer
                    this.$nextTick(() => {
                        if (this.uploadingCount === 0) {
                            // 更新 imgList
                            this.imgList = this.propertiesList;
                            this.shows();
                            this.loading = false;
                        }
                    });
                });
        },

        // 压缩图片
        async imageFileProcess (file) {
            const extensionTest = file.name.substring(file.name.lastIndexOf('.') + 1);
            if (extensionTest !== 'jpeg' && extensionTest !== 'jpg' && extensionTest !== 'png' && extensionTest !== 'gif') {
                return file;
            }
            const minimize = this.compressImage
                ? await imageMinimize(file, this.compressQuality, this.maxSize)
                : file;
                
            return minimize;
        },

        // 处理上传成功回调参数
        callbackFileInfo (res) {
            return {
                propertiesValue: res.data.downUrl,
                propertiesName: res.data.name,
                propertiesType: this.getFileType(res.data.name)
            };
        },

        // 拖动点击上传
        async submitUpload (uploadData) {
            if (this.cancelUpload) {
                return;
            }
            this.uploadingCount++; // 开始上传
            const theFile = await this.imageFileProcess(uploadData.file);
            const file = new File([theFile], uploadData.file.name, {
                type: uploadData.file.type
            });
            this.loading = true;
            const formData = new FormData();
            formData.append('file', file);
            formData.append('bucket', this.bucket);
            formData.append('businessKey', this.businessKey);
            formData.append('publicRead', this.publicRead);
            formData.append('contentType', this.contentType);
            
            ossUpload(formData)
                .then((res) => {
                    if (res && +res.code === 0) {
                        const list = {
                            ...res
                        };
                        list.data.name = uploadData.file.name;
                        list.data.size = file.size;
                        // 保存文件的 uid，用于匹配 uploadFileList
                        list.uid = uploadData.file.uid;
                        this.uploadList.push(list);
                        this.propertiesList.push(this.callbackFileInfo(list));
                        // 上传成功后，从 uploadFileList 中移除对应的文件
                        if (this.multiple && uploadData.file.uid) {
                            const fileIndex = this.uploadFileList.findIndex(
                                f => f.uid === uploadData.file.uid
                            );
                            if (fileIndex > -1) {
                                this.uploadFileList.splice(fileIndex, 1);
                            }
                        }
                    }
                })
                .finally(() => {
                     this.uploadingCount--;
                    // 统一刷新 只有当没有上传任务时才刷新 Viewer
                    this.$nextTick(() => {
                        if (this.uploadingCount === 0) {
                            // 更新 imgList
                            this.imgList = this.propertiesList;
                            this.shows();
                            this.loading = false;
                        }
                    });
                });
        },

        // 对文件名称特殊字符进行转换，否则会报接口异常
        amazonEscape(name) {
            return encodeURIComponent(name);
        },

        // 除了下面这些字符外，其它都可以上传，参考oss接口上传文档
        _amazonShouldEscape(c) {
            const specialList = ['?', '/', '\\', '*', '|', '"', '<', '>'];
            return specialList.includes(c);
        }

    },
    mounted () {
        this.shows();
    }
};
</script>

<style lang="less">
.dragAndCopyUpload {
    .currentImgIndex {
        text-align: center;
    }

    .contentBox-img {
        width: 100%;
    }

    .dragAndCopyUpload-class {
        text-align: center;

        .notImg {
        border-radius: 4px;
        border: 2px dashed #00bcbf;
        color: #00bcbf;
        width: 120px;
        line-height: 120px;
        font-size: 50px;
        text-align: center;
        }

        .el-upload-dragger {
            width: auto;
            height: auto;
            line-height: 1;
            overflow: auto;
        }

    }

    .drag-tip {
        display: flex;
        line-height: 30px;
        justify-content: center;
        margin-top: 10px;
        text-align: center;
        font-size: 14px !important;
    }

    .input-upload-copy{
            text-align: center;
        .input-upload-paste {
            text-align: center;
            height: 20px;
            width: 80%;
            margin-top: 5px;
            border-radius: 3%;
            border: 1px solid #00bcbf;
        }
    }

      .uploader {
        padding-top: 6px;
        text-align: center;

        > div {
            display: inline-block;
            vertical-align: top;
        }
        .pictures {
            border-radius: 4px;
            border: 1px dashed #00bcbf;
            color: #00bcbf;
            width: 20px;
            line-height: 20px;
        }
        > i {
            cursor: pointer;
            color: #00bcbf;
            font-size: 22px;
            vertical-align: middle;
            margin-left: 30px;
        }
    }

}
</style>